import { getExternalScriptClient } from '@carvana/analytics';
import { axios } from '@carvana/purchase-utils';

export const loadPlaid = callback =>
  getExternalScriptClient('Plaid', `${process.env.PLAID_URL}`, callback);

const getPlaidLinkToken = async () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/paymentcollection/GetLinkPlaidToken`
  })
    .then(res => res.data)
    .then(res => ({ token: res?.link_token }));

const createLinkToken = () =>
  axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data: {},
    url: `${process.env.CUSTOMER_VERIFICATIONS_API_URL}/api/v2/Plaid/create-link-token`
  })
    .then(res => res.data)
    .then(res => ({ token: res?.linkToken }));

export const openPlaid = ({
  user,
  trackPlaidEvent = () => {},
  isBAV = false
}) =>
  new Promise(async (resolve, reject) => {
    const token = isBAV ? await createLinkToken() : await getPlaidLinkToken();

    // eslint-disable-next-line no-undef
    const plaidHandler = Plaid.create({
      clientName: 'Carvana',
      env: `${process.env.PLAID_ENV}`,
      ...token,
      user,
      product: process.env.PLAID_PRODUCTS.split(','),
      selectAccount: true,
      apiVersion: 'v2',
      onSuccess: (publicToken, metadata) => resolve({ publicToken, metadata }),
      onEvent: (eventName, metadata) => {
        if (eventName !== 'TRANSITION_VIEW') {
          trackPlaidEvent(eventName, metadata);
        }
      },
      onExit: (error, metadata) => {
        trackPlaidEvent(
          `ERROR${error ? `_${error.display_message}` : ''}`,
          metadata
        );
        return error != null ? reject(error.display_message) : reject();
      }
    });

    plaidHandler.open();
  });
